/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from "react";
import { CircularProgress, SwipeableDrawer } from "@mui/material";
import { swalConfirm, swalError, swalSuccess } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import {
  ActionsColumnFormatter,
  FileColumnFormater,
  RowSelection,
  StatusColumnFormatter,
  TopPaginationHandler,
  UniTableComponent,
} from "@unisearch/helpers/tableHelpers";
import { reactSelectStyleAdmin } from "@unisearch/helpers/utils";
import Link from "next/link";
import { useRouter } from "next/router";
import { FiSearch } from "react-icons/fi";
import { IoMdTrash } from "react-icons/io";
import { MdVerticalSplit } from "react-icons/md";
import Select from "react-select";
import MediaForm from "./mediaForm";

export const MediaList = (props) => {
  const router = useRouter();

  //Drawer State management
  const [drawerState, setDrawerState] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerState(open);
  };

  //media types
  const meditTypes = [
    { label: "Select", value: "" },
    { label: "Image", value: "image" },
    { label: "PDF", value: "pdf" },
    { label: "Video", value: "video" },
  ];

  //sidebar
  const [showSidebar, setShowSidebar] = useState(false);
  const toggleSidebar = () => {
    setShowSidebar((prev) => !prev);
  };

  //Pagination information
  const [paginationInfo, setPaginationInfo] = useState({
    currentPage: 1,
    limit: 20,
  });

  //all data
  const [entities, setEntities] = useState([]);
  const [statusOverview, setStatusOverview] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [mediaId, setMediaId] = useState(false);
  const [listLoading, setListLoading] = useState(false);

  //initiet state
  const [serachFilter, setSearchFilterState] = useState({
    filter: { status: "Active", mediaName: "", tag: "" },
    sortOrder: "DESC",
    sortField: "mediaManagerId",
    pageNumber: paginationInfo.currentPage ?? 1,
    pageSize: paginationInfo.limit ?? 20,
  });

  //get pate with filter
  const getAllData = async (filter = false) => {
    setListLoading(true);
    await API.post(
      "/media-manager/find-mediaFile",
      filter ? filter : serachFilter
    )
      .then((res) => {
        if (res.statusCode == 201 && !res.error) {
          setEntities(res?.data?.results);
          setPaginationInfo({
            currentPage: res?.data?.currentPage,
            limit: res?.data?.limit,
            nextPage: res?.data?.nextPage,
            page_total: res?.data?.page_total,
            previousPage: res?.data?.previousPage,
            totalRows: res?.data?.total,
          });
          setListLoading(false);
        } else {
          swalError(res.message);
        }
      })
      .catch((error) => {
        swalError(error);
      });
    setListLoading(false);
  };

  //get overview
  const getOverview = async () => {
    await API.get("/media-manager/status-overview")
      .then((res) => {
        if (res.statusCode == 200 && !res.error) {
          setStatusOverview(res.data);
        }
      })
      .catch((error) => {
        swalError(error);
      });
  };

  //get overview
  useEffect(() => {
    getOverview();
  }, []);

  //effect when laod or change page
  useEffect(() => {
    getAllData();
  }, [
    serachFilter.pageNumber,
    serachFilter.pageSize,
    serachFilter.sortField,
    serachFilter.sortOrder,
    serachFilter.filter.status,
  ]);

  const getActiveLink = (value = false) => {
    if (serachFilter?.filter?.status && serachFilter?.filter?.status == value) {
      return "active";
    } else if (value == "all" && !serachFilter?.filter?.status) {
      return "active";
    }
  };

  //when change keywords
  const handleKeyword = (e) => {
    setSearchFilterState((prev) => ({
      ...prev,
      filter: { ...serachFilter.filter, mediaName: e.target.value },
      pageNumber: 1,
    }));
  };

  //when press enter
  const handleKeyUp = (event) => {
    if (event.key === "Enter") {
      getAllData();
    } else {
      setTimeout(() => {
        getAllData();
      }, 1000);
    }
  };

  //handle status
  const handleFilterStatus = (status = "Active") => {
    const newFilter = { ...serachFilter, filter: {} };

    if (status != "all") {
      newFilter.filter.status = status;
    }

    setSearchFilterState(newFilter);
  };

  //paginationHandler
  const handleTableChange = (type, tableprops) => {
    if (type == "pagination") {
      setSearchFilterState((prev) => ({
        ...prev,
        pageNumber: tableprops.page,
        pageSize: tableprops.sizePerPage,
      }));
    }
    if (type == "sort") {
      setSearchFilterState((prev) => ({
        ...prev,
        sortOrder: tableprops.sortOrder.toUpperCase(),
        sortField: tableprops.sortField,
      }));
    }
  };

  //handleRestore
  const handleRestore = async (row) => {
    await API.patch("/media-manager/change-status", {
      ids: [parseInt(row.mediaManagerId)],
      status: "Active",
    }).then((res) => {
      if (!res.error) {
        swalSuccess("Item Restore Successfully");
        getOverview();
        getAllData();
      } else {
        swalError(res.message);
      }
    });
  };

  //handleDelete
  const handleDelete = (row) => {
    if (row.status == "Deleted") {
      handleHardDelete([parseInt(row.mediaManagerId)]);
    } else {
      handleSoftDelete([parseInt(row.mediaManagerId)]);
    }
  };

  const handleSoftDelete = async (ids) => {
    swalConfirm("to Trash this item", "Are you sure").then(async (cnf) => {
      if (cnf.isConfirmed) {
        await API.patch("/media-manager/change-status", {
          ids: ids,
          status: "Deleted",
        }).then((res) => {
          if (!res.error) {
            swalSuccess("Item Deleted Successfully");
            getOverview();
            getAllData();
          } else {
            swalError(res.message);
          }
        });
      }
    });
  };

  //handleDelete
  const handleHardDelete = (ids) => {
    swalConfirm("to delete", "Are you sure").then(async (cnf) => {
      if (cnf.isConfirmed) {
        await API.patch("/media-manager/hard-delete", {
          ids: ids,
        }).then((res) => {
          if (!res.error) {
            swalSuccess("Item Deleted Successfully");
            getOverview();
            getAllData();
          } else {
            swalError(res.message);
          }
        });
      }
    });
  };

  //handleEdit
  const handleEdit = (row) => {
    setDrawerState(true);
    setMediaId(row.mediaManagerId);
  };
  const viewMediaAction = async (row) => {
    //
  };

  //reset fitlered
  const handleReset = (e) => {
    let newSf = {
      ...serachFilter,
      filter: { status: "Active" },
      pageNumber: 1,
    };
    //reset state
    setSearchFilterState(newSf);

    //get data
    getAllData(newSf);
  };

  const drawerHandler = () => {
    setDrawerState(false);
    setMediaId(false);
    getAllData();
  };

  const columns = [
    {
      dataField: "src",
      text: "Media File",
      formatter: FileColumnFormater,
      style: {
        width: "130px",
      },
    },
    {
      dataField: "mediaName",
      text: "Name",
      sort: true,
    },
    {
      dataField: "fileType",
      text: "File Type",
      sort: true,
      style: {
        width: "100px",
      },
    },
    {
      dataField: "fileSize",
      text: "File Size",
      style: {
        width: "100px",
      },
    },
    {
      dataField: "alt",
      text: "ALT Text",
      style: {
        width: "300px",
      },
    },
    {
      dataField: "status",
      formatter: StatusColumnFormatter,
      text: "Status",
      style: {
        width: "100px",
      },
    },
    {
      dataField: "",
      text: "Actions",
      formatter: ActionsColumnFormatter,
      formatExtraData: {
        editAction: handleEdit,
        viewMediaAction: viewMediaAction,
        deleteAction: handleDelete,
        restoreAction: handleRestore,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        width: "100px",
      },
    },
  ];

  return (
    <Fragment>
      <div className={`action_header`}>
        {/* action left */}
        <div className={`action_header_left`}>
          <ul className={`action_header_left_list`}>
            <li
              onClick={() => {
                handleFilterStatus("all");
              }}
              className={getActiveLink("all")}
            >
              All
            </li>
            <li
              onClick={() => {
                handleFilterStatus("Active");
              }}
              className={getActiveLink("Active")}
            >
              Published ({statusOverview?.active ?? "0"})
            </li>
            {/* <li
              onClick={() => {
                handleFilterStatus("Inactive");
              }}
              className={getActiveLink("Inactive")}
            >
              Inactive ({statusOverview?.pending ?? "0"})
            </li>
            <li
              onClick={() => {
                handleFilterStatus("Draft");
              }}
              className={getActiveLink("Draft")}
            >
              Draft ({statusOverview?.draft ?? "0"})
            </li> */}

            <li
              onClick={() => {
                handleFilterStatus("Deleted");
              }}
              className={getActiveLink("Deleted")}
            >
              Trash ({statusOverview?.trash ?? "0"})
            </li>

            {selectedIds && selectedIds.length > 0 && (
              <li>
                <button
                  onClick={() => {
                    if (serachFilter.filter.status == "Deleted") {
                      handleHardDelete(selectedIds.map(Number));
                    } else {
                      handleSoftDelete(selectedIds.map(Number));
                    }
                  }}
                  className={`action_delete`}
                >
                  <IoMdTrash className={`action_delete_icon`} />
                  Delete
                </button>
              </li>
            )}
            <li>
              <div className={`action_search`}>
                {listLoading ? (
                  <CircularProgress size={10} className={`action_loading`} />
                ) : (
                  <FiSearch className={`action_search_icon`} />
                )}

                <FiSearch className={`action_search_icon`} />
                <input
                  type="text"
                  placeholder="Search Here"
                  name="mediaName"
                  value={serachFilter?.filter?.mediaName}
                  onChange={handleKeyword}
                  onKeyUp={handleKeyUp}
                />
              </div>
            </li>
          </ul>
        </div>

        {/* action right */}
        <div className={`action_header_right`}>
          <Link legacyBehavior href="/app/university/media/new">
            <a className={`admin btn btn-primary`}>Add New</a>
          </Link>

          <TopPaginationHandler
            paginationInfo={paginationInfo}
            paginationHandler={handleTableChange}
          />

          <button className={`sidebar_toggle`} onClick={toggleSidebar}>
            <MdVerticalSplit />
          </button>
        </div>
      </div>

      <div className="admin_page_wrapper">
        {/* Table */}
        <div
          className={`admin_table_wrapper ${
            showSidebar ? `sidebar_present` : ""
          }`}
        >
          {entities && entities?.length == 0 ? (
            <div className="no_record_found">No record found</div>
          ) : (
            <UniTableComponent
              data={entities ?? []}
              columns={columns}
              keyField="mediaManagerId"
              page={paginationInfo.currentPage}
              sizePerPage={paginationInfo.limit}
              totalSize={paginationInfo.totalRows ?? 0}
              onTableChange={handleTableChange}
              selectRow={RowSelection(
                selectedIds,
                setSelectedIds,
                "mediaManagerId"
              )}
            />
          )}
        </div>
      </div>

      {/* Sidebar open */}
      <div
        className={`filter_sidebar ${showSidebar ? `filter_sidebar_open` : ""}`}
      >
        <div className={`filter_sidebar_header`}>
          <div className="filter_sidebar_title">FILTERS</div>
        </div>
        <div className={`filter_sidebar_body`}>
          <div className={`admin_form_group`}>
            <label htmlFor="role" className={`admin_label`}>
              Media Types
            </label>

            <Select
              menuPortalTarget={
                typeof document !== "undefined" ? document.body : ""
              }
              id={`types`}
              name="roleId"
              instanceId={`roleId`}
              placeholder="Select One"
              styles={reactSelectStyleAdmin}
              options={meditTypes ?? []}
              value={
                serachFilter?.filter?.tag && meditTypes
                  ? meditTypes.filter(
                      (item) => item.value === serachFilter?.filter?.tag
                    )
                  : ""
              }
              onChange={(item) => {
                setSearchFilterState((prev) => ({
                  ...prev,
                  filter: {
                    ...serachFilter.filter,
                    tag: item.value,
                  },
                }));
              }}
            />
          </div>
        </div>
        <div className={`filter_sidebar_footer `}>
          <button
            className={`admin btn btn-admin-outline`}
            onClick={handleReset}
          >
            {listLoading ? (
              <CircularProgress size={15} style={{ color: "grey" }} />
            ) : (
              ``
            )}
            Reset
          </button>

          <button
            className={`admin btn btn-primary`}
            onClick={() => {
              getAllData();
            }}
          >
            {listLoading ? (
              <CircularProgress size={15} style={{ color: "white" }} />
            ) : (
              ``
            )}
            Apply
          </button>
        </div>
      </div>
      {mediaId && (
        <SwipeableDrawer
          anchor={"right"}
          open={drawerState}
          onClose={toggleDrawer(true)}
          onOpen={toggleDrawer(true)}
          classes={{ paper: "admin_drawer" }}
        >
          <MediaForm drawerHandler={drawerHandler} mediaManagerId={mediaId} />
        </SwipeableDrawer>
      )}
    </Fragment>
  );
};

export default MediaList;
